/**
 * Structure d'appui par défaut des AVEC : toute AVEC sans programme choisi est
 * suivie par elle, et peut en changer à tout moment.
 *
 * Copie exacte de DEFAULT_SUPPORT_PROGRAM (Wanzo_Backend,
 * packages/shared/src/config/default-support-program.ts) : même identifiant,
 * même nom, pour que toutes les apps l'affichent pareil.
 */
export const DEFAULT_SUPPORT_PROGRAM = {
  id: '1e1c0de0-a0e1-4c0d-8e1c-000000000001',
  name: 'Réseau ikiotahub',
  sigle: 'RIH',
} as const;

export function isDefaultSupportProgram(id: string | null | undefined): boolean {
  return !!id && id === DEFAULT_SUPPORT_PROGRAM.id;
}
